module.exports = __webpack_public_path__ + "img/package.692c9448.png";